import React, { useState, useEffect, useRef } from "react";

const AUTOHIDE_DELAY = 2000; // milisegundos

const AudioBackground = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(0.5);
  const [visible, setVisible] = useState(false);
  const playerRef = useRef(null);
  const hideTimeout = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://w.soundcloud.com/player/api.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    let widget;
    if (isPlaying && window.SC && playerRef.current) {
      widget = window.SC.Widget(playerRef.current);
      widget.bind(window.SC.Widget.Events.READY, () => {
        widget.setVolume(volume * 50);
        widget.play();
      });
      widget.bind(window.SC.Widget.Events.FINISH, () => {
        widget.seekTo(0);
        widget.play();
      });
    }
    return () => {
      if (widget) {
        widget.unbind(window.SC.Widget.Events.FINISH);
      }
    };
  }, [isPlaying, volume]);

  const handleStart = () => {
    setIsPlaying(true);
    setVisible(true);
    startAutoHide();
  };

  const handleStop = () => {
    setIsPlaying(false);
    setVisible(false);
    if (window.SC && playerRef.current) {
      const widget = window.SC.Widget(playerRef.current);
      widget.pause();
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    if (isPlaying && window.SC && playerRef.current) {
      const widget = window.SC.Widget(playerRef.current);
      widget.setVolume(newVolume * 50);
    }
  };

  // Mostrar el panel al pasar el mouse por la parte superior
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (e.clientY < 40) {
        setVisible(true);
        startAutoHide();
      }
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  // Ocultar el panel después de un tiempo sin interacción
  const startAutoHide = () => {
    if (hideTimeout.current) clearTimeout(hideTimeout.current);
    hideTimeout.current = setTimeout(() => setVisible(false), AUTOHIDE_DELAY);
  };

  const handlePanelMouseEnter = () => {
    setVisible(true);
    if (hideTimeout.current) clearTimeout(hideTimeout.current);
  };

  const handlePanelMouseLeave = () => {
    startAutoHide();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        zIndex: 9999,
        background: "transparent",
        pointerEvents: "none", // Permite que solo el panel reciba eventos
      }}
    >
      <div
        onMouseEnter={handlePanelMouseEnter}
        onMouseLeave={handlePanelMouseLeave}
        style={{
          pointerEvents: "auto",
          transition: "transform 0.3s, opacity 0.3s",
          transform: visible ? "translateY(0)" : "translateY(-100%)",
          opacity: visible ? 1 : 0,
          background: "transparent",
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
          minHeight: 36,
          
        }}
      >
        {!isPlaying ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 0,
            }}
          >
            <button
              onClick={handleStart}
              style={{
                background: "#e0e0e0",
                color: "#333",
                border: "none",
                borderRadius: "16px",
                padding: "6px 18px",
                fontSize: "0.95rem",
                fontWeight: "normal",
                cursor: "pointer",
                transition: "background 0.2s",
                letterSpacing: "0.5px",
                height: 32,
                lineHeight: "20px",
                marginRight: 8,
              }}
            >
              Iniciar experiencia con música
            </button>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
              minHeight: 0,
            }}
            className="volume-control"
          >
            <label
              style={{ color: "#fff", fontWeight: "bold", fontSize: "0.95rem" }}
            >
              Volumen:{" "}
            </label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={volume}
              onChange={handleVolumeChange}
              style={{ accentColor: "#ff5500", height: 4 }}
            />
            <button
              onClick={handleStop}
              style={{
                background: "#e0e0e0",
                color: "#333",
                border: "none",
                borderRadius: "16px",
                padding: "6px 18px",
                fontSize: "0.95rem",
                fontWeight: "normal",
                cursor: "pointer",
                transition: "background 0.2s",
                letterSpacing: "0.5px",
                height: 32,
                lineHeight: "20px",
                marginLeft: 8,
              }}
            >
              Detener
            </button>
          </div>
        )}
        <iframe
          ref={playerRef}
          id="sc-player"
          width="0"
          height="0"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A%2F%2Fsoundcloud.com%2Flecastlevania%2Fnobody-gets-out-alive-pt-3&color=%23ff5500&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false"
        ></iframe>
      </div>
    </div>
  );
};

export default AudioBackground;
